/** Resolves the authoritative workspace mirror for a project's client company. */

type WorkspaceMirror = {
  id?: string;
  legacy_company_id?: string;
  legacyCompanyId?: string;
};

export function resolveProjectWorkspaceId(
  clientId: string | undefined,
  workspaces: Record<string, WorkspaceMirror> | undefined,
  explicitWorkspaceId?: string,
): string | undefined {
  if (!clientId) return undefined;

  for (const workspace of Object.values(workspaces || {})) {
    if (
      workspace?.legacy_company_id === clientId ||
      workspace?.legacyCompanyId === clientId
    ) {
      return workspace.id;
    }
  }

  return explicitWorkspaceId;
}
